import {NuxtIcon} from "#components";
import {h} from "vue";
import { createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue"

const _hoisted_1 = {
  xmlns: "http://www.w3.org/2000/svg",
  fill: "none",
  viewBox: "0 0 57 56"
}

export function render(_ctx, _cache) {
  return (_openBlock(), _createElementBlock("svg", _hoisted_1, _cache[0] || (_cache[0] = [
    _createElementVNode("path", {
      fill: "#fff",
      d: "m28.688 18.967-3.74 17.242h-4.522l3.74-17.242h4.522ZM47.714 30.1l2.38-6.474 1.37 6.474h-3.75Zm5.047 6.108h4.182l-3.653-17.24h-3.858c-.869 0-1.602.496-1.926 1.263L40.72 36.208h4.75l.943-2.574h5.8l.548 2.575ZM40.956 30.58c.02-4.55-6.378-4.802-6.335-6.836.014-.617.611-1.276 1.917-1.444.648-.082 2.435-.149 4.46.772l.793-3.658c-1.088-.388-2.488-.762-4.23-.762-4.471 0-7.616 2.343-7.641 5.7-.029 2.481 2.246 3.865 3.957 4.692 1.764.845 2.355 1.387 2.346 2.142-.012 1.157-1.406 1.669-2.704 1.688-2.275.035-3.594-.606-4.645-1.09l-.821 3.78c1.058.478 3.009.894 5.028.915 4.753 0 7.86-2.315 7.875-5.9Zm-18.73-11.613L14.898 36.21h-4.78l-3.606-13.76c-.219-.846-.41-1.157-1.074-1.515-1.088-.582-2.883-1.127-4.461-1.466l.107-.5h7.695c.98 0 1.862.643 2.086 1.756l1.905 9.978 4.704-11.735h4.752Z"
    }, null, -1)
  ])))
}
export default { render() { return h(NuxtIcon, {icon: {render}, name: "visa"}) } }